// extracted by mini-css-extract-plugin
module.exports = {"header":"MobileNavigationHeaderMenuGroup_header__1HYQ7","headerText":"MobileNavigationHeaderMenuGroup_headerText__AsAdc","sending":"MobileNavigationHeaderMenuGroup_sending__3jd9S"};